import { OnInit, AfterViewInit, inject } from '@angular/core';
import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[pageheight]',
  standalone: false  //NOSONAR
})
export class PageheightDirective implements OnInit, AfterViewInit {
  private el = inject(ElementRef);

  constructor() {
    this.setPageHeight();
  }
  ngOnInit(): void {
    // window.dispatchEvent(new Event('resize'));
    this.setPageHeight();
  }

  ngAfterViewInit(): void {
    // Defer to ensure browser has completed layout before measuring element position.
    // ngOnInit may run before getBoundingClientRect returns correct values (e.g. inside tab panels).
    requestAnimationFrame(() => this.setPageHeight());
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setPageHeight();
  }

  setPageHeight() {
    const windowHt = $(window).height() ?? 0;
    const elementTop = (this.el.nativeElement as HTMLElement).getBoundingClientRect().top;

    // Use the nearest overflow:hidden ancestor as the true clip boundary so the
    // element fills exactly the available space regardless of vibe/non-vibe mode.
    if (elementTop > 0) {
      let parent = (this.el.nativeElement as HTMLElement).parentElement;
      while (parent && parent !== document.body) {
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'hidden' || style.overflowY === 'hidden') {
          const parentRect = parent.getBoundingClientRect();
          if (parentRect.height > 100) {
            const pageHeight = parentRect.bottom - elementTop;
            if (pageHeight > 0) {
              this.el.nativeElement.style.height = `${pageHeight}px`;
              return;
            }
          }
        }
        parent = parent.parentElement;
      }
    }

    // Fallback: legacy calculation for cases where no clip ancestor is found
    const headerHt = $('#vbHeader').outerHeight() ?? 0;
    let pageHeaderHt = $('#vbPageHeader').outerHeight();
    pageHeaderHt = pageHeaderHt ? pageHeaderHt : 0;
    const artifactsBarHt = $('.artifacts-bar-container').outerHeight() ?? 0;
    const pageHeight = windowHt - (headerHt + pageHeaderHt + artifactsBarHt + 60);
    this.el.nativeElement.style.height = `${pageHeight}px`;
  }
}
